import React from "react";
import  { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import "react-big-calendar/lib/css/react-big-calendar.css";
import EventWeek from './EventWeek';
import EventDay from './EventDay';
import EventMonth from './EventMonth';
import { ToolBarView } from "./ToolBarView";
import useWindowSize from "../../hooks/useWindowSize";

function AppointmentCalendar({events}) {
  
  const localizer = momentLocalizer(moment)
  const windowSize = useWindowSize();

  const dayFormat = windowSize.width >= windowSize.tailwind.xl ? 'dddd' : 'dd';
  const formats = {
    weekdayFormat: (date, culture, localizer) => localizer.format(date, dayFormat, culture),
  }
  
  return (
    <Calendar
      messages={{ showMore: (count) => <div className="text-xs font-normal mt-1">+{count} more Appointments</div>}} 
      localizer={localizer}
      formats={formats}
      events={events}
      startAccessor="start"
      endAccessor="end"
      components={{
        // event: EventComponent,
        toolbar: props => ( <ToolBarView {...props} />),
        week: {
          event: EventWeek,
        },
        day: {
          event: EventDay,
        },
        month: {
          event: EventMonth,
        },
      }}
    />
  );
}

export default AppointmentCalendar;
